import JobDescription from "../../../../Components/JobDescription";

const UiUxDesign = () => {
  return (
   
    <JobDescription
      jobTitle="UI UX Designer"
      location="Chennai"
      department="UI UX"
      jobType="Full-Time"
      experienceLevel="Experienced"
      roleDescription="We're on the hunt for a UI/UX Designer who's creative, detail-obsessed, and user-focused. At {brandName}, you'll design seamless digital experiences across web and mobile—bringing ideas to life with purpose and polish."
      responsibilities={[
        "Design clean, intuitive interfaces for Web & Mobile",
        "Use modern wireframes, flows, and UI mockups",
        "Collaborate with Devs, PMs & Content teams",
        "Do user research & usability testing",
        "Build and maintain design systems",
        "Ensure brand consistency across all touchpoints",
        "Iterate based on feedback & user data",
      ]}
      skills={[
        "Figma, Adobe XD, Sketch",
        "Prototyping & Design Systems",
        "UX Research & Accessibility",
        "Attention to detail & a good design sense",
        "Bonus: Basic HTML/CSS knowledge",
      ]}
      requirements={[
        "Have 1–3 years' experience or a killer portfolio",
        "Can think from a user's POV",
        "Communicate and collaborate well",
        "Love turning complex ideas into simple, beautiful UIs",
      ]}
      benefits={[
        "At Ideal, you're not just designing screens—you're shaping brands.",
        "We're a creative tech team that values ownership, learning, and meaningful work.",
        "We keep things flexible, fun, and focused.",
      ]}
      onApply={() => console.log("Applied for UI UX Designer")}
      applyUrl="/apply/ui-ux-designer"
    />
  );
};

export default UiUxDesign;
